
import { Component, Vue, Watch } from 'vue-property-decorator';
import debounce from 'lodash/debounce';
import {
  Client,
  NetworkModel,
  ServiceTypeModel,
  ClientSearchResultModel,
  IJobModel,
  JobModel,
  IJobItemModel,
  JobItemModel,
  LocationModel,
  IJobItemScheduleModel,
  Status as JobItemModelStatus,
  EmployeeModel
} from '@/services/api.service';
import {
  JobItemType,
  Status,
  JobType,
  AreaType,
  EnumModel,
  StatusEnums,
  JobTypeEnums,
  JobItemTypeEnums,
  AreaTypeEnums
} from '@/common/enumerations';
import JobItemEdit from '../processes/JobItemEdit.vue';
import {
  JobItemScheduleUpdatedMessage,
  JobItemStatusChangedMessage,
  JobItemUpdatedMessage
} from '@/services/eventbus.models';
import { EventBus } from '@/event-bus';
import * as DateUtils from '@/utilities/date.utils';

import toJobItemTypeFormatter from '@/filters/jobitemtype.formatter';
import toStatusFormatter from '@/filters/status.formatter';
import toDateFormatter from '@/filters/todate.formatter';

@Component({
  components: {
    JobItemEdit
  },
  props: {
    jobItem: {
      type: Object as () => IJobItemModel,
      required: false
    },
    jobGid: String,
    jobNumber: String
  },
  filters: {
    toJobItemType: toJobItemTypeFormatter,
    toStatus: toStatusFormatter,
    toDate: toDateFormatter
  }
})
export default class JobItemCard extends Vue {
  private schedule: IJobItemScheduleModel | null = null;
  private status: Status = Status.Pending;
  private hasCurrentSchedule: boolean = false;

  protected created() {
    EventBus.$on('job-item-scheduled', (message: JobItemScheduleUpdatedMessage) => {
      this.handleJobItemScheduledEvent(message);
    });
    EventBus.$on('job-item-status-changed', (message: JobItemStatusChangedMessage) => {
      this.handleJobItemStatusChangedEvent(message);
    });
    EventBus.$on('job-item-updated', (message: JobItemUpdatedMessage) => {
      this.handleJobItemUpdatedEvent(message);
    });
  }

  protected mounted() {
    // get the networks
    // Object.assign(this.data, this.$props.jobItem);
    // console.log('JobItemCard:localdatamodel');
    // console.log(this.data);
    this.status = (this.$props.jobItem.status as any) as Status;
    this.fetchCurrentSchedule(this.$props.jobGid, this.$props.jobItem.gid);
  }
  protected beforeDestroy() {
    EventBus.$off('job-item-scheduled');
    EventBus.$off('job-item-status-changed');
    EventBus.$off('job-item-updated');
  }

  @Watch('jobItem', { immediate: false, deep: true })
  private onjobItemChanged(oldValue: IJobItemModel, newValue: IJobItemModel) {
    console.log('watched job item changed:');
    console.log(oldValue);
    console.log(newValue);
  }

  private handleJobItemScheduledEvent(message: JobItemScheduleUpdatedMessage) {
    console.log('EVENTBUS: received job-item-scheduled message');
    console.log(message);

    if (message.jobItemGid === this.$props.jobItem.gid) {
      // Got a new schedule for the job item card
      if (message.data !== null) {
        this.updateScheduleModel(message.data);
      }
    }
  }

  private handleJobItemStatusChangedEvent(message: JobItemStatusChangedMessage) {
    console.log('EVENTBUS: received job-item-status-changed message');
    console.log(message);
    if (message.data !== null) {
      if (message.data.gid === this.$props.jobItem.gid) {
        // Got a new schedule for the job item card
        this.status = message.newStatus; // as any as JobItemModelStatus;
      }
    }
  }

  private handleJobItemUpdatedEvent(message: JobItemUpdatedMessage) {
    console.log('EVENTBUS: received job-item-updated message');
    console.log(message);
    if (message.data !== null) {
      if (message.data.gid === this.$props.jobItem.gid) {
        // Just update the status for the moment. The rest
        // of the property changes are pushed in via the
        // $props.jobItem
        this.status = (message.data.status as any) as Status;
      }
    }
  }

  private async fetchCurrentSchedule(jobgid: string, jobItemGid: string) {
    const clientService = new Client(process.env.VUE_APP_API_URL, this.$http);
    const [theJobItemSchedule] = await Promise.all([clientService.getCurrentJobItemSchedule(jobgid, jobItemGid)]);

    if (theJobItemSchedule !== null) {
      this.updateScheduleModel(theJobItemSchedule);
    }
  }

  private updateScheduleModel(data: IJobItemScheduleModel) {
    this.schedule = data;
    this.hasCurrentSchedule = true;
  }

  private editJobItem() {
    this.$emit('on-edit-jobitem', this.$props.jobItem);
  }

  private addJobItemActivity() {
    this.$emit('on-add-jobitem-activity', this.$props.jobItem);
  }
  private scheduleJobItem() {
    this.$emit('on-schedule-jobitem', this.$props.jobItem);
  }
  private createInvoice() {
    this.$emit('on-create-jobitem-invoice', this.$props.jobItem);
  }

  private transitionJobItem() {
    this.$emit('on-transition-jobitem', this.$props.jobItem);
  }

  private getStatus(value: number) {
    return toStatusFormatter(value).toLowerCase();
  }
}
